export default "__VITE_ASSET__Bxn7jIEo__"